export default {
    slug: 'payments',
    portalRoutes: [
        {
            path: 'payment-methods',
            name: 'portal-payment-methods',
            component: () => import('@modules/Payments/Resources/js/portal/PaymentMethods.vue')
        }
    ],
    settingsRoutes: [
        {
            path: 'payments/gateways',
            name: 'settings-payments-gateways',
            component: () => import('@modules/Payments/Resources/js/pages/settings/Gateways.vue'),
            props: true
        },
        {
            path: 'payments/payouts',
            name: 'settings-payments-payouts',
            component: () => import('@modules/Payments/Resources/js/pages/settings/Payouts.vue'),
            props: true
        }
    ],
    settings: () => [
        {
            title: i18n.t('Payments'),
            order: 22,
            items: [
                {
                    title: i18n.t('Gateways'),
                    icon: 'credit-card-multiple',
                    route: 'settings-payments-gateways',
                    permission: 'settings.stripe'
                },
                {
                    title: i18n.t('Stripe payouts'),
                    icon: 'bank-transfer-in',
                    route: 'settings-payments-payouts',
                    permission: 'settings.stripe'
                }
            ]
        }
    ]
};
